import { render, staticRenderFns } from "./IndexNotifiq.vue?vue&type=template&id=58b430ba&scoped=true"
import script from "./IndexNotifiq.vue?vue&type=script&lang=js"
export * from "./IndexNotifiq.vue?vue&type=script&lang=js"
import style0 from "./IndexNotifiq.vue?vue&type=style&index=0&id=58b430ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b430ba",
  null
  
)

export default component.exports